module.exports = __webpack_public_path__ + "ca2a8015d29223892b5ff9a3ee8d0478.jpg";